import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { closeModal } from '../../actions/Modal';
import { ModalTitle } from '../../components/Modal/Modal';
import SignupModalButtons from '../../components/Onboarding/SignupModalButtons';
import { messages as AuthMessages } from '../../constants/Anon';
import { UsageMessages } from '../../constants/Usage';
import { AsyncDomain } from '../../domains';

export const DefaultSignupModalBody = connect(null, { closeModal })(
  class extends React.Component {
    static propTypes = {
      closeModal: PropTypes.func.isRequired,
      escKeyPressed: PropTypes.bool,
    };

    componentWillReceiveProps(nextProps) {
      if (nextProps.escKeyPressed && this.props.escKeyPressed !== nextProps.escKeyPressed) {
        this.closeModal();
      }
    }

    closeModal = () => {
      this.props.closeModal();
    };

    render() {
      return (
        <div>
          <ModalTitle>
            <FormattedMessage {...AuthMessages.signUpFree} />.
          </ModalTitle>
          <SignupModalButtons closeModal={this.closeModal} />
        </div>
      );
    }
  },
);

export const TimedoutSignupModalBody = connect(null, { closeModal })(
  class extends React.Component {
    static propTypes = {
      closeModal: PropTypes.func.isRequired,
      escKeyPressed: PropTypes.bool,
    };

    componentWillReceiveProps(nextProps) {
      if (nextProps.escKeyPressed && this.props.escKeyPressed !== nextProps.escKeyPressed) {
        this.closeModal();
      }
    }

    closeModal = () => {
      this.props.closeModal();
    };

    render() {
      return (
        <div>
          <ModalTitle>
            <FormattedMessage {...UsageMessages.anonymousTimeoutReached} />
          </ModalTitle>
          <AsyncDomain domain='playback' component='SignupTracks' />
          <SignupModalButtons closeModal={this.closeModal} />
        </div>
      );
    }
  },
);
